import React, { useContext, useState } from 'react';
import { block } from 'bem-cn';

import { ModalContext } from '../ModalProvider';
import SVG from 'components/SVG';

import './Modal.scss';

import crossSVG from '../img/cross.svg';

const b = block('modal');

const Modal = ({ content, title, isMobile }) => {
  const { closeModal } = useContext(ModalContext);

  const [isClosing, setIsClosing] = useState(false);

  const handleClose = () => {
    setIsClosing(true);

    const closeTimeout = setTimeout(() => {
      closeModal();
      clearTimeout(closeTimeout);
    }, 175);
  };

  return (
    <div onClick={handleClose} className={b({ disappearing: isClosing })}>
      <div onClick={e => e.stopPropagation()} className={b('body', { disappearing: isClosing, isMobile })}>
        <div className={b('header', { isMobile })}>
          <div className={b('title')}>{title}</div>
          <SVG onClick={handleClose} className={b('cross')} svgProps={{ svg: crossSVG }} />
        </div>
        <div className={b('content', { isMobile })}>{content}</div>
      </div>
    </div>
  );
};

export default Modal;
